import script from "./FoilPeelForm.vue?vue&type=script&setup=true&lang=js"
export * from "./FoilPeelForm.vue?vue&type=script&setup=true&lang=js"

import "./FoilPeelForm.vue?vue&type=style&index=0&id=1e2bf48f&lang=css"

const __exports__ = script;

export default __exports__